import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { SpacingToken, Text } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { AutomationsSectionHeader } from "./AutomationsSectionHeader";

interface IProps {
  description: string;
  templates: ReactNode;
}
export const AutomationsTemplatesSection: FC<IProps> = ({ description, templates }) => (
  <Wrapper>
    <AutomationsSectionHeader title="Ready-made templates" />
    <Text>{description}</Text>
    {templates}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${withVar(SpacingToken.Spacing5)};
`;
